import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"id":"logo-behance","fill":"props.strokeColor1","d":"M7.1092 5C7.82831 5 8.48392 5.06339 9.07614 5.1904C9.66835 5.3173 10.1759 5.52547 10.5989 5.8142C11.0218 6.10328 11.3497 6.48757 11.5824 6.96706C11.815 7.44655 11.9313 8.03865 11.9313 8.7436C11.9313 9.50509 11.7586 10.1396 11.4132 10.647C11.0676 11.1546 10.5566 11.5705 9.87989 11.8949C10.8104 12.1628 11.5048 12.6319 11.9632 13.3013C12.421 13.9712 12.6507 14.7785 12.6507 15.723C12.6507 16.4843 12.5027 17.1437 12.2064 17.7007C11.9105 18.2579 11.5119 18.7125 11.0116 19.0645C10.511 19.4172 9.93991 19.6779 9.29847 19.8474C8.65301 20.0169 7.98832 20.1021 7.32097 20.1009H0.00292969V5H7.1092ZM6.68625 11.1125C7.27847 11.1125 7.7648 10.9715 8.14561 10.6894C8.52629 10.4075 8.71658 9.94916 8.71658 9.31469C8.71658 8.96233 8.65319 8.67313 8.5263 8.44755C8.3994 8.22209 8.23025 8.04549 8.01871 7.91884C7.80718 7.79182 7.56395 7.70406 7.28903 7.65436C7.00626 7.60442 6.71961 7.57968 6.43246 7.58041H3.32346V11.1126L6.68625 11.1125ZM6.87653 17.5206C7.20068 17.5206 7.51101 17.4888 7.80706 17.4254C8.10311 17.3619 8.36386 17.2562 8.58968 17.108C8.81502 16.9602 8.99486 16.7591 9.12896 16.5052C9.26282 16.2516 9.32981 15.9273 9.32981 15.5323C9.32981 14.7571 9.11107 14.2037 8.6742 13.8722C8.23697 13.5409 7.65892 13.3751 6.93992 13.3751H3.32346V17.5204L6.87653 17.5206ZM16.8294 17.2035C17.2805 17.6409 17.9292 17.8591 18.7752 17.8591C19.3812 17.8591 19.9031 17.7078 20.3401 17.4044C20.7772 17.1016 21.0451 16.7806 21.1438 16.4421H23.7875C23.3647 17.7533 22.7158 18.6911 21.8418 19.2549C20.9673 19.819 19.9098 20.1009 18.6692 20.1009C17.8091 20.1009 17.0335 19.9635 16.3427 19.6884C15.6516 19.4136 15.0664 19.0222 14.5874 18.5147C14.1079 18.0072 13.7378 17.4013 13.4769 16.696C13.2159 15.9912 13.0858 15.2155 13.0858 14.3695C13.0858 13.5519 13.2194 12.7906 13.4876 12.0855C13.7552 11.3807 14.1357 10.7708 14.6298 10.2559C15.1229 9.74147 15.7118 9.33606 16.3957 9.03989C17.0794 8.74372 17.8373 8.59581 18.6693 8.59581C19.5999 8.59581 20.4105 8.77553 21.1017 9.13509C21.7923 9.49452 22.3599 9.97798 22.8043 10.5838C23.2483 11.1901 23.5689 11.8812 23.7667 12.6563C23.9641 13.432 24.0343 14.2426 23.9782 15.0886H16.0894C16.1315 16.0613 16.3778 16.7666 16.8294 17.2035ZM20.2238 11.4508C19.8644 11.0562 19.3178 10.8586 18.5849 10.8586C18.1054 10.8586 17.7072 10.9398 17.39 11.1018C17.0727 11.2642 16.8188 11.4647 16.6284 11.7046C16.4382 11.9444 16.304 12.1983 16.2267 12.4659C16.149 12.7339 16.1032 12.9736 16.0891 13.1851H20.9747C20.8337 12.4236 20.5835 11.8456 20.2238 11.4508ZM15.5763 5.76678H21.6804V7.45927H15.5763V5.76678Z"}}]};

const LogoBehance = Vue.extend<IconProps>({
  name: 'LogoBehanceIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-behance',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoBehance;
